/** Public landing at "/". Minimal, web3: a full-screen centered wordmark, login
 *  top-right, one CTA. The console + login live at "/admin/". */
export function Landing() {
  return (
    <div className="lpx">
      <nav className="lpx-nav">
        <span className="lpx-mark">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <defs>
              <linearGradient id="lpx-logo" x1="0" y1="0" x2="20" y2="20">
                <stop offset="0%" stopColor="#ff6a5e" />
                <stop offset="100%" stopColor="#f8392f" />
              </linearGradient>
            </defs>
            <circle cx="10" cy="10" r="8" stroke="url(#lpx-logo)" strokeWidth="1.6" />
            <circle cx="10" cy="10" r="3" fill="url(#lpx-logo)" />
          </svg>
          Praxis
        </span>
        <a className="lpx-login" href="/admin/">
          Log in <span className="arrow">↗</span>
        </a>
      </nav>

      <main className="lpx-center">
        <span className="lpx-eyebrow">The authorization layer for the Cosmos interchain</span>
        {/* prettier-ignore */}
        <h1 className="lpx-title">Prax<span className="lpx-i"><span className="lpx-i-dot" /></span>s</h1>
        <p className="lpx-sub">
          Non-custodial treasury automation <span className="dot-accent">·</span> Cosmos interchain
        </p>
        <a className="lpx-cta" href="/admin/">
          Enter the console <span className="arrow">→</span>
        </a>
      </main>

      <footer className="lpx-foot">
        <span>Non-custodial</span>
        <span className="sep">·</span>
        <span>On-chain audit</span>
        <span className="sep">·</span>
        <span>You keep your keys</span>
      </footer>
    </div>
  );
}
